export enum rulePrecedenceDirection {
    Up,
    Down
}


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/rules/directives/rulesDialog/models/rulePrecedenceDirectionEnum.ts
 **/